

export const LOGIN = 'LOGIN';